import { Badge, Tooltip } from '@mantine/core';

import { registryOrderCountryName } from '@/types/registry-documents';

/**
 * The orange "Mentions Mozambique" pill an email carries when its text
 * names a country. An annotation only: the desk's quote for a Zimbabwe
 * order once said "Mozambique", and a person has to notice. With the
 * order's country known, the hover says what the order is for.
 */
export function CountryMentionBadge({
  codes,
  orderCountryCode,
}: Readonly<{
  /** ISO-2 codes of the countries the email names. */
  codes: string[];
  /** The order's own country, when the email is on one. */
  orderCountryCode?: string | null;
}>) {
  if (codes.length === 0) {
    return null;
  }
  const names = codes.map(registryOrderCountryName).join(', ');
  const badge = (
    <Badge size="xs" variant="light" color="orange" data-testid="registry-country-mention">
      Mentions {names}
    </Badge>
  );
  if (!orderCountryCode) {
    return badge;
  }
  return (
    <Tooltip label={`The order is for ${registryOrderCountryName(orderCountryCode)}`}>
      {badge}
    </Tooltip>
  );
}
